import * as React from "react";
import { forwardRef } from "react";
const SvgPackages = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ React.createElement("svg", {
	viewBox: "0 0 25 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props
}, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("rect", {
	x: 3.5,
	y: 12.0033,
	width: 9,
	height: 9,
	rx: 2,
	stroke: "currentColor",
	strokeWidth: 1.5
}), /* @__PURE__ */ React.createElement("rect", {
	x: 12.5,
	y: 12.0033,
	width: 9,
	height: 9,
	rx: 2,
	stroke: "currentColor",
	strokeWidth: 1.5
}), /* @__PURE__ */ React.createElement("rect", {
	x: 8.12012,
	y: 2.9967,
	width: 9,
	height: 9,
	rx: 2,
	stroke: "currentColor",
	strokeWidth: 1.5
}), /* @__PURE__ */ React.createElement("path", {
	d: "M18.5 17.7014L21.5002 17.7014",
	stroke: "currentColor",
	strokeWidth: 1.5,
	strokeLinecap: "round"
}), /* @__PURE__ */ React.createElement("path", {
	d: "M9.5 17.7014L12.5002 17.7014",
	stroke: "currentColor",
	strokeWidth: 1.5,
	strokeLinecap: "round"
}), /* @__PURE__ */ React.createElement("path", {
	d: "M14.1201 8.99658L17.1203 8.99658",
	stroke: "currentColor",
	strokeWidth: 1.5,
	strokeLinecap: "round"
}));
const ForwardRef = forwardRef(SvgPackages);
export default ForwardRef;
